import { getImageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import * as React from 'react';
import ReactPlayer from 'react-player/lazy';
import S from './LandingPageHeroBanner.styles';
const LandingPageHeroBanner = ({ autoPlay: initialAutoPlay = true, autoPlayInterval = 5000, items, ...props }) => {
    const isSingleItem = items.length === 1;
    const refTimeout = React.useRef(0);
    const [activeId, setActiveId] = React.useState(items[0].id);
    const [autoPlay, setAutoPlay] = React.useState(initialAutoPlay && !isSingleItem);
    React.useEffect(() => {
        if (!autoPlay) {
            return;
        }
        refTimeout.current = window.setTimeout(() => {
            const index = items.findIndex((item) => item.id === activeId);
            const nextItem = items[index + 1];
            setActiveId(nextItem?.id ?? items[0].id);
        }, autoPlayInterval);
        return () => {
            if (refTimeout.current) {
                clearTimeout(refTimeout.current);
            }
        };
    }, [activeId, autoPlay]);
    return (React.createElement(S.Container, { id: props.id, flush: "both", fullWidth: true, "data-autoplay": autoPlay },
        items.map((item, i) => (React.createElement(S.Item, { key: item.id, style: { '--tint': item.tintAmount }, "aria-current": item.id === activeId },
            item.image || item.video ? (React.createElement(S.ImageWrapper, { "data-has-video": !!item.video },
                item.image && (React.createElement("picture", null,
                    React.createElement("source", { media: from(Device.Tablet), srcSet: [
                            `${getImageUrl(item.image, {
                                mode: 'crop',
                                width: 1024,
                                height: 600,
                            })} 1024w`,
                            `${getImageUrl(item.image, {
                                mode: 'crop',
                                width: 1366,
                                height: 600,
                            })} 1366w`,
                            `${getImageUrl(item.image, {
                                mode: 'crop',
                                width: 1600,
                                height: 600,
                            })} 1600w`,
                            `${getImageUrl(item.image, {
                                mode: 'crop',
                                width: 1920,
                                height: 600,
                            })} 1920w`,
                        ].join(',') }),
                    React.createElement(S.Image, { loading: "eager", alt: item.altText, role: item.altText ? undefined : 'presentation', src: getImageUrl(item.mobileImage ? item.mobileImage : item.image, {
                            mode: 'crop',
                            width: 375,
                            heightratio: 0.5625,
                        }), srcSet: [
                            `${getImageUrl(item.mobileImage ? item.mobileImage : item.image, {
                                mode: 'crop',
                                width: 375,
                                heightratio: 0.5625,
                            })} 375w`,
                            `${getImageUrl(item.mobileImage ? item.mobileImage : item.image, {
                                mode: 'crop',
                                width: 480,
                                heightratio: 0.5625,
                            })} 480w`,
                            `${getImageUrl(item.mobileImage ? item.mobileImage : item.image, {
                                mode: 'crop',
                                width: 768,
                                heightratio: 0.5625,
                            })} 768w`,
                            `${getImageUrl(item.mobileImage ? item.mobileImage : item.image, {
                                mode: 'crop',
                                width: 1024,
                                heightratio: 0.5625,
                            })} 1024w`,
                        ].join(',') }))),
                item.video && (React.createElement(S.Video, null,
                    React.createElement(ReactPlayer, { width: "100%", height: "100%", playsinline: true, playing: item.id === activeId, controls: false, url: item.video, muted: true, loop: true }))))) : null,
            React.createElement(S.ContentWrapper, null,
                item.title && React.createElement(S.Title, { as: i === 0 ? 'h1' : undefined }, item.title),
                item.content && React.createElement(S.Content, null, item.content),
                item.cta && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { branding: "tertiary", href: item.cta.url, target: item.cta.target, title: item.cta.text }))))))),
        !isSingleItem && (React.createElement(S.Controls, { style: { '--autoplay-interval': `${autoPlayInterval}ms` } },
            React.createElement(SiteWide, null, items.map((item, index) => (React.createElement(S.ControlItem, { key: item.id, "aria-current": item.id === activeId, onClick: (event) => {
                    event.preventDefault();
                    setAutoPlay(false);
                    setActiveId(item.id);
                } },
                React.createElement(S.BaseLine, null),
                React.createElement(S.Highlight, null),
                React.createElement(S.Label, null,
                    "Go to ",
                    index + 1)))))))));
};
export default LandingPageHeroBanner;
